import Prototype from "./WaveFunctionCollapseV2/Prototype/Prototype.ts";
import Vector3 from "./WaveFunctionCollapseV2/Utils/Vector3.ts";
import { DIRECTIONS } from "./WaveFunctionCollapseV2/Constants/Direction.ts";

export default class PrototypeImpl implements Prototype {
  id: string;
  mesh_name: string;
  mesh_rotation: number;
  posX: string;
  negX: string;
  posY: string;
  negY: string;
  posZ: string;
  negZ: string;
  constrain_to: string;
  constrain_from: string;
  weight: number;
  valid_neighbours: {
    posX: string[];
    negX: string[];
    posY: string[];
    negY: string[];
    posZ: string[];
    negZ: string[];
  };

  constructor(
    id: string,
    mesh_name: string,
    mesh_rotation: number,
    posX: string,
    negX: string,
    posY: string,
    negY: string,
    posZ: string,
    negZ: string,
    constrain_to: string,
    constrain_from: string,
    weight: number,
    valid_neighbours: {
      posX: string[];
      negX: string[];
      posY: string[];
      negY: string[];
      posZ: string[];
      negZ: string[];
    },
  ) {
    this.id = id;
    this.mesh_name = mesh_name;
    this.mesh_rotation = mesh_rotation;
    this.posX = posX;
    this.negX = negX;
    this.posY = posY;
    this.negY = negY;
    this.posZ = posZ;
    this.negZ = negZ;
    this.constrain_to = constrain_to;
    this.constrain_from = constrain_from;
    this.weight = weight;
    this.valid_neighbours = valid_neighbours;
  }

  getPossiblePrototypeIdsInDirection(direction: Vector3): string[] {
    if (direction.equals(DIRECTIONS.posX)) {
      return this.valid_neighbours.posX;
    } else if (direction.equals(DIRECTIONS.negX)) {
      return this.valid_neighbours.negX;
    } else if (direction.equals(DIRECTIONS.posY)) {
      return this.valid_neighbours.posY;
    } else if (direction.equals(DIRECTIONS.negY)) {
      return this.valid_neighbours.negY;
    } else if (direction.equals(DIRECTIONS.posZ)) {
      return this.valid_neighbours.posZ;
    } else if (direction.equals(DIRECTIONS.negZ)) {
      return this.valid_neighbours.negZ;
    } else {
      console.error("Invalid direction");
      return [];
    }
  }
}
